import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import PortfolioDetail from "components/cards/PortfolioDetailsTwoCards";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { PortfolioData } from "../assets/portfolioData";

const GrayLinkBase = tw.a` h-full text-gray-500 font-bold hover:text-primary-500`;
const Post = tw.div` h-full text-primary-500 font-bold inline-block`;
const Content = tw.div`max-w-screen-xl mx-auto pt-8 lg:pt-12`;

export default () => {
  const params = useParams();

  const details = PortfolioData.filter((item) => {
    return item.id == params.id;
  });

  return (
    <AnimationRevealPage>
      <Header />
      <Content>
        <GrayLinkBase href={`/`}>Home</GrayLinkBase>
        <span tw="text-gray-500 mx-2"> / </span>
        <GrayLinkBase href={`/portfolio`}>Portfolio</GrayLinkBase>
        <span tw="text-gray-500 mx-2"> / </span>
        <Post>Portfolio Detail</Post>
      </Content>
      <PortfolioDetail
        subheading={details[0].subheading}
        heading={details[0].heading}
        description={details[0].description}
        projectImage={details[0].projectImage}
      />
      <Footer />
    </AnimationRevealPage>
  );
};
